import { useEffect } from "react";

const DEFAULT_TITLE =
    "Beeta Logistics — Transportation Beyond Compare | 3PL, Warehousing & Auto Logistics in India";
const DEFAULT_DESC =
    "Beeta Logistics is one of India's leading integrated 3PL providers — warehousing, transporting, in-plant, auto-industry and cold-chain logistics. Since 2015: 28 branches, 6+ warehouses, 10,000+ operations, trusted by 100+ leading OEMs and Tier-1 suppliers across India.";

function upsertMeta(name, content, isProperty = false) {
    if (!content) return;
    const attr = isProperty ? "property" : "name";
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function upsertCanonical(href) {
    if (!href) return;
    let el = document.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

/**
 * Set per-page <title>, meta description and OG/Twitter equivalents.
 * Falls back to site defaults if a value is omitted.
 */
export default function useSeo({ title, description, path }) {
    useEffect(() => {
        const finalTitle = title ? `${title} | Beeta Logistics` : DEFAULT_TITLE;
        const finalDesc = description || DEFAULT_DESC;
        const finalUrl = path
            ? `https://www.beetalogistics.com${path}`
            : "https://www.beetalogistics.com/";

        document.title = finalTitle;
        upsertMeta("description", finalDesc);
        upsertMeta("og:title", finalTitle, true);
        upsertMeta("og:description", finalDesc, true);
        upsertMeta("og:url", finalUrl, true);
        upsertMeta("twitter:title", finalTitle);
        upsertMeta("twitter:description", finalDesc);
        upsertCanonical(finalUrl);
    }, [title, description, path]);
}
